(() => {
  "use strict";
  const ENDPOINT = "https://pwckrgpsvfdwjwsyguwp.supabase.co/functions/v1/ranker-event";
  const C = window.TablissaRankerContext || {};
  const impressionSeen = new Set();
  const clickSeen = new Set();

  function uid(storage, key) {
    try {
      let v = storage.getItem(key);
      if (!v) {
        v = (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2));
        storage.setItem(key, v);
      }
      return v;
    } catch (_) {
      return String(Date.now()) + Math.random().toString(16).slice(2);
    }
  }
  const sessionId = uid(sessionStorage, "tablissa_ranker_session");
  const visitorId = uid(localStorage, "tablissa_ranker_visitor");

  function numeric(v) {
    const m = String(v ?? "").match(/(\d{6,20})/);
    return m ? Number(m[1]) : null;
  }
  function collectionHandle() {
    if (C.collectionHandle) return C.collectionHandle;
    const m = location.pathname.match(/^\/collections\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function materialFromText(v) {
    const s = String(v || "").toLowerCase();
    if (s.includes("kanvas")) return "Kanvas";
    if (s.includes("mdf")) return "MDF";
    if (s.includes("poster")) return "Poster";
    return "";
  }
  function detectMaterial(scope = document) {
    const checked = scope.querySelectorAll?.('input:checked, option:checked') || [];
    for (const el of checked) {
      const label = el.id ? document.querySelector('label[for="' + CSS.escape(el.id) + '"]')?.textContent : "";
      const m = materialFromText([el.value, el.name, label, el.textContent].join(" "));
      if (m) return m;
    }
    const selects = scope.querySelectorAll?.("select") || [];
    for (const el of selects) {
      const opt = el.options?.[el.selectedIndex];
      const m = materialFromText([el.name, el.value, opt?.textContent].join(" "));
      if (m) return m;
    }
    return "";
  }
  function productInfoFromNode(node) {
    if (!node) return {};
    const host = node.closest?.("[data-product-id], product-card, product-component, [data-product-handle]") || node;
    let productId =
      numeric(host?.dataset?.productId) ||
      numeric(host?.getAttribute?.("data-product-id")) ||
      numeric(node?.dataset?.productId);
    if (!productId) {
      productId = numeric(host?.querySelector?.('[name="product-id"], [data-product-id]')?.value);
    }
    let handle =
      host?.dataset?.productHandle ||
      host?.getAttribute?.("data-product-handle") ||
      null;
    if (!handle) {
      const a = host?.querySelector?.('a[href*="/products/"]') || node.closest?.('a[href*="/products/"]');
      const m = a?.getAttribute("href")?.match(/\/products\/([^/?#]+)/);
      if (m) handle = m[1];
    }
    return { productId, handle, host };
  }
  function send(eventType, data = {}) {
    const productId = numeric(data.productId ?? C.productId);
    if (!productId) return;
    const payload = {
      event_type: eventType,
      session_id: sessionId,
      visitor_id: visitorId,
      product_id: productId,
      variant_id: numeric(data.variantId ?? C.variantId),
      product_handle: data.handle ?? C.productHandle ?? null,
      material: data.material ?? detectMaterial(data.host || document),
      collection_handle: data.collectionHandle ?? collectionHandle(),
      path: location.pathname + location.search,
      referrer: document.referrer || "",
      metadata: data.metadata || {}
    };
    try {
      const body = JSON.stringify(payload);
      if (navigator.sendBeacon) {
        const blob = new Blob([body], { type: "application/json" });
        if (navigator.sendBeacon(ENDPOINT, blob)) return;
      }
      fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
        credentials: "omit"
      }).catch(() => {});
    } catch (_) {}
  }

  const io = "IntersectionObserver" in window ? new IntersectionObserver(entries => {
    for (const e of entries) {
      if (!e.isIntersecting || e.intersectionRatio < 0.45) continue;
      const info = productInfoFromNode(e.target);
      if (!info.productId || impressionSeen.has(info.productId)) continue;
      impressionSeen.add(info.productId);
      send("impression", info);
      io.unobserve(e.target);
    }
  }, { threshold: [0.45] }) : null;

  function registerCards(root = document) {
    if (!io) return;
    if (root.matches?.("[data-product-id]")) io.observe(root);
    root.querySelectorAll?.("[data-product-id]").forEach(el => io.observe(el));
  }

  function trackProductPage() {
    if ((C.pageType === "product" || String(C.template || "").startsWith("product")) && C.productId) {
      send("product_view", {
        productId: C.productId,
        variantId: C.variantId,
        handle: C.productHandle,
        material: detectMaterial(document)
      });
    }
  }

  async function trackCheckoutFromCart() {
    try {
      const r = await fetch("/cart.js", { credentials: "same-origin", cache: "no-store", keepalive: true });
      if (!r.ok) throw new Error("cart");
      const cart = await r.json();
      for (const item of cart.items || []) {
        send("checkout_started", {
          productId: item.product_id,
          variantId: item.variant_id,
          handle: item.handle,
          material: materialFromText([item.variant_title, ...(item.options_with_values || []).map(x => x.value)].join(" ")),
          metadata: {
            quantity: item.quantity,
            line_price: item.final_line_price ?? item.line_price ?? null,
            cart_total: cart.total_price ?? null
          }
        });
      }
    } catch (_) {
      if (C.productId) send("checkout_started", { productId: C.productId, material: detectMaterial(document) });
    }
  }

  document.addEventListener("click", e => {
    const a = e.target.closest?.('a[href*="/products/"]');
    if (a) {
      const info = productInfoFromNode(a);
      if (info.productId) {
        const k = info.productId + "|" + location.pathname;
        if (!clickSeen.has(k)) {
          clickSeen.add(k);
          send("product_click", info);
        }
      }
    }
    const checkout = e.target.closest?.('button[name="checkout"], input[name="checkout"], a[href*="/checkout"], [data-checkout]');
    if (checkout) trackCheckoutFromCart();
  }, true);

  document.addEventListener("change", e => {
    const t = e.target;
    const material = materialFromText([
      t?.value, t?.name, t?.id,
      t?.id ? document.querySelector('label[for="' + CSS.escape(t.id) + '"]')?.textContent : ""
    ].join(" "));
    if (!material) return;
    const info = C.productId ? { productId:C.productId, variantId:C.variantId, handle:C.productHandle, host:document } : productInfoFromNode(t);
    if (info.productId) send("material_select", { ...info, material });
  }, true);

  document.addEventListener("submit", e => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = form.getAttribute("action") || "";
    if (action.includes("/cart/add")) {
      const info = C.productId ? { productId:C.productId, handle:C.productHandle, host:form } : productInfoFromNode(form);
      const variant = form.querySelector('[name="id"]')?.value;
      if (info.productId) {
        send("add_to_cart", {
          ...info,
          variantId: variant || C.variantId,
          material: detectMaterial(form)
        });
      }
    }
    if (action.includes("/checkout") || form.querySelector('[name="checkout"]')) trackCheckoutFromCart();
  }, true);

  document.addEventListener("DOMContentLoaded", () => {
    trackProductPage();
    registerCards(document);
    const mo = new MutationObserver(records => {
      for (const r of records) for (const n of r.addedNodes) if (n.nodeType === 1) registerCards(n);
    });
    mo.observe(document.documentElement, { childList:true, subtree:true });
  }, { once:true });
})();